export class ImageItem {
    url: string;
    isLinked: boolean = false;
}
